import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useLoginMutation } from "../../redux/adminApi";
import Field from "../ui/Field";
import { errorMessage } from "../../lib/format";

export default function Login() {
  const { login, authenticated, me } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [doLogin, { isLoading }] = useLoginMutation();

  useEffect(() => {
    if (authenticated) navigate(location.state?.from || (me?.is_owner || me?.permissions?.includes("dashboard") ? "/dashboard" : "/order-history"), { replace: true });
  }, [authenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email.trim() || !form.password) return setError("Enter your email and password");
    setError("");
    const res = await doLogin({ email: form.email.trim(), password: form.password });
    if (res.error) return setError(errorMessage(res.error));
    login(res.data.authtoken);
  };

  return (
    <div className="login">
      <div className="login-art">
        <img src="/assets/images/logo.png" alt="Zillionaire Jewels" />
      </div>
      <div className="login-form">
        <form onSubmit={submit} noValidate>
          <h1>Store admin</h1>
          <p className="muted" style={{ marginBottom: 24 }}>
            Sign in with your owner or staff account.
          </p>
          {error ? (
            <p className="alert bad" role="alert" style={{ marginBottom: 14 }}>
              {error}
            </p>
          ) : null}
          <Field label="Email" type="email" autoComplete="username" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <Field label="Password" type="password" autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button className="btn" style={{ width: "100%", height: 42 }} disabled={isLoading}>
            {isLoading ? <span className="spinner" /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
